import * as React from 'react';
import { styled } from '@mui/material/styles';

const SectionContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  borderBottom: '1px solid #E9EAEE',
  width: '100%'
});

const SectionType = styled('div')({
  padding: '17px 0px',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '12px',
  letterSpacing: '1px',
  color: '#2C3542'
});

export interface IProps {
  children?: React.ReactNode;
  header: string | React.ReactElement;
}

const AccordionSectionType: React.FC<IProps> = props => {
  return (
    <SectionContainer>
      <SectionType>
        <label>{props.header}</label>
      </SectionType>
      {props.children}
    </SectionContainer>
  );
};

export default AccordionSectionType;
